var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMotiondiv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 94,
    viewBox: "0 0 108 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_8264_81761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 32C32 24.268 38.268 18 46 18H62C69.732 18 76 24.268 76 32V48C76 55.732 69.732 62 62 62H46C38.268 62 32 55.732 32 48V32Z",
    fill: "url(#paint0_linear_8264_81761)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_8264_81761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 32C32 24.268 38.268 18 46 18H62C69.732 18 76 24.268 76 32V48C76 55.732 69.732 62 62 62H46C38.268 62 32 55.732 32 48V32Z",
    fill: "url(#paint1_linear_8264_81761)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 40C45 41.78 45.5278 43.5201 46.5168 45.0001C47.5057 46.4802 48.9113 47.6337 50.5558 48.3149C52.2004 48.9961 54.01 49.1743 55.7558 48.8271C57.5016 48.4798 59.1053 47.6226 60.364 46.364C61.6226 45.1053 62.4798 43.5016 62.8271 41.7558C63.1743 40.01 62.9961 38.2004 62.3149 36.5558C61.6337 34.9113 60.4802 33.5057 59.0001 32.5168C57.5201 31.5278 55.78 31 54 31C51.484 31.0095 49.069 31.9912 47.26 33.74L45 36",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 31V36H50",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_8264_81761)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_8264_81761",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 22C66 18.6863 68.6863 16 72 16C75.3137 16 78 18.6863 78 22C78 25.3137 75.3137 28 72 28C68.6863 28 66 25.3137 66 22Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66 22C66 18.6863 68.6863 16 72 16C75.3137 16 78 18.6863 78 22C78 25.3137 75.3137 28 72 28C68.6863 28 66 25.3137 66 22Z",
    fill: "url(#paint2_linear_8264_81761)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 22M78 22M78 22M66 22M72 16M78 22M72 28M66 22M72 28V26C69.7909 26 68 24.2091 68 22H66H64C64 26.4183 67.5817 30 72 30V28ZM78 22H76C76 24.2091 74.2091 26 72 26V28V30C76.4183 30 80 26.4183 80 22H78ZM72 16V18C74.2091 18 76 19.7909 76 22H78H80C80 17.5817 76.4183 14 72 14V16ZM72 16V14C67.5817 14 64 17.5817 64 22H66H68C68 19.7909 69.7909 18 72 18V16Z",
    fill: "white",
    mask: "url(#path-5-inside-1_8264_81761)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8264_81761",
    x: 0,
    y: -14,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_8264_81761"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_8264_81761",
    x: 20,
    y: 16,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8264_81761"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8264_81761"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8264_81761"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8264_81761",
    result: "effect2_dropShadow_8264_81761"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8264_81761",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_8264_81761",
    x: 54,
    y: 14,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8264_81761"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8264_81761"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8264_81761"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8264_81761",
    result: "effect2_dropShadow_8264_81761"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8264_81761",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8264_81761",
    x1: 32,
    y1: 18,
    x2: 76,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD46FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7008E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8264_81761",
    x1: 32,
    y1: 18,
    x2: 76,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD46FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7008E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8264_81761",
    x1: 66,
    y1: 16,
    x2: 78,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD46FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7008E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotiondiv);
export default __webpack_public_path__ + "static/media/motion.div.e39e01b570d6f15867e0eaca94ef3ea2.svg";
export { ForwardRef as ReactComponent };